import { Box, Text, Button, VStack } from "@chakra-ui/react";
import { FiTool } from "react-icons/fi";

const NoTools = () => {
  return (
    <Box
      w="100%"
      minH="250px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      p={6}
    >
      <VStack spacing={3}>
        <FiTool size={50} color="#718096" />
        <Text fontWeight="bold" fontSize="lg" color="gray.700">
          No tools found
        </Text>
        <Text fontSize="sm" color="gray.500">
          Add your first tool to get started
        </Text>
      </VStack>
    </Box>
  );
};

export default NoTools;
